import styled from 'styled-components';
import List from 'react-chatview';

export const Container = styled(List)`
  height: calc(100vh - 61px);
`;

export const Category = styled.div`
  position: relative;

  img {
    width: 50px;
    height: 50px;
  }

  a {
    border: 1px solid #3a3a3a;
    box-shadow: 0px 13px 19px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
  }

  button {
    top: 15px;
    right: 30px;
  }

  .btn-edit {
    bottom: 15px;
    right: 30px;
    width: 27px;
    height: 27px;
    border-radius: 50%;
  }
`;
